import React, { useState } from 'react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/20/solid';
import { Popover } from '@headlessui/react';
import { useTranslations } from 'next-intl';
import { MobileSecondLevelMenuProps } from '../MobileSecondLevelMenu/types/MobileSecondLevelMenuProps';
import MobileSecondLevelMenu from '../MobileSecondLevelMenu';
import { HeaderContent } from '../../header';
import { HeaderMobileMenuItem } from './header-mobile-menu-item';

export function HeaderMobileMenu({ headerData }: Readonly<{ headerData: HeaderContent }>) {
  const t = useTranslations('Header');
  const [secondLevelMenu, setSecondLevelMenu] = useState<
  MobileSecondLevelMenuProps['menuData'] | null
  >(null);

  return (
    <Popover className="flex h-full items-center rounded-r-md duration-200 ease-in hover:bg-neutral-5 lg:hidden">
      {({ open }) => (
        <>
          <Popover.Button
            className="h-full w-full px-4 sm:px-6"
            aria-label={t('openMainMenu')}
            data-tile-element-id="nav-mobile-menu"
          >
            {open ? (
              <XMarkIcon className="h-6 w-auto" aria-hidden="true" />
            ) : (
              <Bars3Icon className="h-6 w-auto" aria-hidden="true" />
            )}
          </Popover.Button>

          <Popover.Panel className="absolute left-0 top-[95%] z-10 h-[calc(100vh-110px)] w-full rounded-b-md border-t border-neutral-10 bg-white p-4 shadow-nuki-blured-no-top">
            {({ close }) => (
              <ul className="flex flex-col gap-5">
                {secondLevelMenu ? (
                  <MobileSecondLevelMenu
                    key={secondLevelMenu.title}
                    menuData={secondLevelMenu}
                    setMenuData={setSecondLevelMenu}
                    close={close}
                  />
                ) : (
                  headerData?.children?.map((link) => (
                    <HeaderMobileMenuItem
                      key={link.id}
                      link={link}
                      close={close}
                      setSecondLevelMenu={setSecondLevelMenu}
                    />
                  ))
                )}
              </ul>
            )}
          </Popover.Panel>
        </>
      )}
    </Popover>
  );
}
